<div class="wrapper" appMousemove>
  <app-scroll-to-top-btn></app-scroll-to-top-btn>
  <app-navigation></app-navigation>
  <app-main></app-main>
  <app-ticker></app-ticker>
  <app-about></app-about>
  <app-rules></app-rules>

  <router-outlet></router-outlet>

  <app-instagram></app-instagram>
  <app-info></app-info>
  <app-footer></app-footer>
</div>
